export const APPROVED = 'APPROVED'
export const PENDING = 'PENDING'